import React, { createContext, useContext, useState } from 'react';

const DataLayerContext = createContext();

export const useDataLayer = () => useContext(DataLayerContext);

export const DataLayerProvider = ({ children }) => {
    const [schoolArray, setSchoolArray] = useState([]);
    const [listArray, setListArray] = useState([]);
    const [sharedListArray, setSharedListArray] = useState([]);
    const [savedQueryArray, setSavedQueryArray] = useState([]);
    const [scoutArray, setScoutArray] = useState([]);
    const [eventArray, setEventArray] = useState([]);
    const [positionArray, setPositionArray] = useState([]);
    const [GPArray, setGPArray] = useState([]);
    const [countryArray, setCountryArray] = useState([]);
    const [agentArray, setAgentArray] = useState([]);
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [savedDate, setSavedDate] = useState(null);
    const [whichOneLiner, setWhichOneLiner] = useState(null);
    const [playerDataLength, setPlayerDataLength] = useState(0);
    const [arrayOfShared, setArrayOfShared] = useState([]);
    const [actualShared, setActualShared] = useState([]);
    const [hwsData, setHWSData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [shortPositionArray, setShortPositionArray] = useState([]);
    const [blinkSQ, setBlinkSQ] = useState(false); // This loads from Table position2s not positiion_fbx_new

    // 🔽 NEW: global dropdown control
    const [openSelectDropDown, setOpenSelectDropdown] = useState(null);

    const updateSchoolArray = (schools) => setSchoolArray(schools);
    const updateListArray = (list) => setListArray(list);
    const updateSharedListArray = (list) => setSharedListArray(list);
    const updateSavedQueryArray = (list) => setSavedQueryArray(list);
    const updateScoutArray = (scouts) => setScoutArray(scouts);
    const updateEventArray = (events) => setEventArray(events);
    const updatePositionArray = (positions) => setPositionArray(positions);
    const updateGPArray = (gpData) => setGPArray(gpData);
    const updateCountryArray = (countries) => setCountryArray(countries);
    const updateAgentArray = (countries) => setAgentArray(countries);
    const updateAutoRefresh = (value) => setAutoRefresh(value);
    const updateSavedDate = (value) => setSavedDate(value);
    const updateWhichOneLiner = (value) => setWhichOneLiner(value);
    const updateArrayOfShared = (value) => setArrayOfShared(value);
    const updateActualShared = (value) => setActualShared(value);
    const updateHWSData = (value) => setHWSData(value);
    const updateReportData = (value) => setReportData(value);
    const updateShortPositionArray = (shortPositions) => setShortPositionArray(shortPositions);
    const triggerBlinkSQ = () => setBlinkSQ(true);
    const resetBlinkSQ = () => setBlinkSQ(false);


    return (
        <DataLayerContext.Provider
            value={{
                schoolArray,
                updateSchoolArray,
                listArray,
                updateListArray,
                savedQueryArray,
                updateSavedQueryArray,
                sharedListArray,
                updateSharedListArray,
                scoutArray,
                updateScoutArray,
                positionArray,
                updatePositionArray,
                shortPositionArray,
                updateShortPositionArray,
                GPArray,
                updateGPArray,
                countryArray,
                updateCountryArray,
                agentArray,
                updateAgentArray,
                eventArray,
                updateEventArray,
                autoRefresh,
                updateAutoRefresh,
                savedDate,
                updateSavedDate,
                whichOneLiner,
                updateWhichOneLiner,
                arrayOfShared,  // in FBX this is the SharedOption - or the list of possible shared items set by Dan
                updateArrayOfShared, // This is the update for the array
                actualShared, // these are the actual teams the user has chosen
                updateActualShared, // this is the update for the actual teams
                hwsData, //used to store the HWS Save Data
                updateHWSData, // used to update the HWS Save Data
                reportData,
                updateReportData,

                // 🔽 expose dropdown control
                openSelectDropDown,
                setOpenSelectDropdown,

                blinkSQ,
                triggerBlinkSQ,
                resetBlinkSQ,
            }}
        >
            {children}
        </DataLayerContext.Provider>
    );
};
